import { TEditorOnChange } from 'com/Editor/Editor/interface';
import { useStableCallback } from 'core/hooks/useStableCallback';

export function useOnMarkAsCorrect(
  question: TQuestion | TQuestionUpdate,
  onChange: TEditorOnChange
) {
  return useStableCallback((idx: number) => {
    if (idx === 0) return;
    const oldCorrectOption = question.options[0];
    onChange({ name: 'options.0', value: question.options[idx] });
    onChange({ name: `options.${idx}`, value: oldCorrectOption });
  });
}
